import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { CardDetail } from '@core/interfaces'
import { PlayerService } from '@shared/services'
import { CardDisplayComponent } from '../card-display/card-display.component'
import { CardTypeEnum } from '@shared/enums'
import { ClassicService } from '@rush-shared/services'
import { Subscription } from 'rxjs'
import { WebSocketService } from '@core/services'
import { ModeEnum } from '@core/enums'
import { CommonModule } from '@angular/common'
import { SeatDto } from '@core/dtos'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-deck-card',
  standalone: true,
  imports: [CardDisplayComponent, CommonModule, SvgIconComponent],
  templateUrl: './deck-card.component.html',
  styleUrl: './deck-card.component.sass',
})
export class DeckCardComponent implements OnInit, OnDestroy {
  private readonly _subscription = new Subscription()

  deckCards: CardDetail[] = []
  modeType = ModeEnum

  get mode(): ModeEnum {
    return this._classicService?.mode$.value || 0
  }
  get isPlayerTurn(): boolean {
    return (
      this.currentSeatNo === this._playerService.currentSeatNoFromDealer &&
      this.mode !== this.modeType.BuyInOpen &&
      this.mode !== this.modeType.Setup
    )
  }

  get playerSeat(): number {
    return this._playerService.currentSeatNoFromDealer
  }

  get currentSeat(): SeatDto | undefined {
    return this._playerService.currentSeat
  }

  get currentSeatNo(): number {
    return this.currentSeat?.seatNo || 0
  }

  showPlayingSeat = false
  seatCount = [1, 2, 3, 4, 5]

  constructor(
    public _classicService: ClassicService,
    private _webSocketService: WebSocketService,
    public _playerService: PlayerService,
  ) {}

  ngOnInit(): void {
    this._subscription.add(
      this._classicService.activeDealer$.subscribe((i) => {
        this._webSocketService.listenToRushPlayerCardsUpdate(i.id, (cards) => {
          this._classicService.setDeckCards(cards)
        })

        this._webSocketService.listenToRushMaverickConfirmation(i.id, (cards) => {
          this._classicService.setDeckCards(cards)
        })

        this._classicService.mode$.observer.subscribe((mode) => {
          if (mode === ModeEnum.Setup || mode === ModeEnum.BuyInOpen) {
            this.showPlayingSeat = false
            this._classicService.setDeckCards([])
          } else {
            this.showPlayingSeat = true
          }
        })
      }),
    )

    this._subscription.add(
      this._classicService.deckCards$.observer.subscribe((cards) => (this.deckCards = cards)),
    )
  }

  buildUrl(card?: CardDetail) {
    if (!card) {
      return ''
    }

    return `assets/cards/${card.cardType}/${card.number}-${card.cardType}.svg`
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
  }
}
